import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Grid, Typography} from '@mui/material';

import {Dispatch, Store} from 'spectra-logic-ui';
import {fetchResource} from 'spectra-logic-ui/actions';
import {Color} from 'spectra-logic-ui/colors';
import {Empty, Loading} from 'spectra-logic-ui/components';

import {SystemCapacity} from '@/types';
import StorageChart from '@/components/storage_chart';

export type Capacity = {
  name?: string;
  used?: number;
  optional?: number;
  total?: number;
}

type Props = {
  id: string;
  capacities: Capacity[];
  className?: string;
  fetchSystemUsage?: () => Promise<any>;
  systemUsage?: SystemCapacity[];
  fetching: boolean;
  fetchingSystemUsage?: boolean;
}

const chartSx = {
  paddingTop: '10px',
  paddingBottom: '10px',
};

const EndpointDetails = ({capacities=[], className='', fetchSystemUsage, systemUsage=[],
  fetching, fetchingSystemUsage}: Props) => {
  useEffect(() => {
    if (fetchSystemUsage) {
      fetchSystemUsage();
    }
  }, []);

  if (fetching || fetchingSystemUsage) {
    return <Loading />;
  }

  if (capacities.length === 0 && systemUsage?.length === 0) {
    return <Empty />;
  }

  return (
    <Grid container className={className}>
      {capacities.length > 0 && <>
        <Grid container>
          <Grid item xs={12} sx={{borderBottom: 'solid 1px darkgray'}}>
            <Typography variant='caption' style={{display: 'block', textAlign: 'center', color: Color.GRAY_DARK}}>
              Storage Capacity
            </Typography>
          </Grid>
          {capacities.map((pool) => (
            <Grid key={pool.name} item xs={6} sm={4} md={3} lg={2} sx={chartSx}>
              <StorageChart heading={pool.name || ''} optional={pool.optional || 0} used={pool.used || 0}
                total={pool.total || 0} />
            </Grid>
          ))}
        </Grid>
      </>}
      {systemUsage.length > 0 && <>
        <Grid container>
          <Grid item xs={12} sx={{borderBottom: 'solid 1px darkgray'}}>
            <Typography variant='caption' style={{display: 'block', textAlign: 'center', color: Color.GRAY_DARK}}>
              System Capacity
            </Typography>
          </Grid>
          {systemUsage.map((su) => (
            <Grid key={su.id} item xs={6} sm={3} md={3} lg={2} sx={chartSx}>
              <StorageChart heading={su.name} optional={0} used={su.used || 0} total={su.total || 0} />
            </Grid>
          ))}
        </Grid>
      </>}
    </Grid>
  );
};

const mapStateToProps = (state: Store, {id}: Props) => {
  const systemUsage = state.resources[`usage/system/${id}`] || {};
  return {
    systemUsage: systemUsage.data || [],
    fetchingSystemUsage: systemUsage.fetching,
  };
};

const mapDispatchToProps = (dispatch: Dispatch, {id}: Props) => ({
  fetchSystemUsage: () => dispatch(fetchResource(`usage/system/${id}`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EndpointDetails);
